require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-secrets-to-building-a-successful-multilingual-e-commerce-store.json") })
        }
      }, "path---blog-secrets-to-building-a-successful-multilingual-e-commerce-store");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-secrets-to-building-a-successful-multilingual-e-commerce-store!./.cache/json/blog-secrets-to-building-a-successful-multilingual-e-commerce-store.json
// module id = 481
// module chunks = 231608221292675